import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-md' : 'bg-white/95 backdrop-blur-sm shadow-sm'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3">
            <div className="w-12 h-12 flex items-center justify-center bg-teal-600 rounded-lg">
              <i className="ri-delete-bin-fill text-2xl text-white"></i>
            </div>
            <span className="text-2xl font-bold text-gray-900">
              El Paso Waste Disposal
            </span>
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            <Link
              to="/dumpster-rentals"
              className="font-medium text-gray-700 hover:text-teal-600 transition-colors"
            >
              Dumpster Rentals
            </Link>
            <Link
              to="/roll-off-dumpster-rentals"
              className="font-medium text-gray-700 hover:text-teal-600 transition-colors"
            >
              Roll Off Rentals
            </Link>
            <Link
              to="/junk-removal"
              className="font-medium text-gray-700 hover:text-teal-600 transition-colors"
            >
              Junk Removal
            </Link>
            <Link
              to="/eviction-clean-out"
              className="font-medium text-gray-700 hover:text-teal-600 transition-colors"
            >
              Eviction Cleanout
            </Link>
            <Link
              to="/distressed-home-ready"
              className="font-medium text-gray-700 hover:text-teal-600 transition-colors"
            >
              Distressed Homes
            </Link>
            <Link
              to="/hoarding-cleanup"
              className="font-medium text-gray-700 hover:text-teal-600 transition-colors"
            >
              Hoarding Cleanup
            </Link>
            <Link
              to="/trash-talk"
              className="font-medium text-gray-700 hover:text-teal-600 transition-colors"
            >
              Trash Talk
            </Link>
            <a
              href="tel:915-233-1754"
              className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-2 rounded-md font-semibold transition-colors whitespace-nowrap cursor-pointer shadow-lg"
            >
              915-233-1754
            </a>
          </nav>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-gray-900 transition-colors"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>

          {isMobileMenuOpen && (
            <div className="lg:hidden absolute top-20 left-0 right-0 bg-white shadow-lg">
              <nav className="flex flex-col p-4 space-y-3">
                <Link
                  to="/dumpster-rentals"
                  className="text-gray-700 hover:text-teal-600 font-medium py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Dumpster Rentals
                </Link>
                <Link
                  to="/roll-off-dumpster-rentals"
                  className="text-gray-700 hover:text-teal-600 font-medium py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Roll Off Rentals
                </Link>
                <Link
                  to="/junk-removal"
                  className="text-gray-700 hover:text-teal-600 font-medium py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Junk Removal
                </Link>
                <Link
                  to="/eviction-clean-out"
                  className="text-gray-700 hover:text-teal-600 font-medium py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Eviction Cleanout
                </Link>
                <Link
                  to="/distressed-home-ready"
                  className="text-gray-700 hover:text-teal-600 font-medium py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Distressed Homes
                </Link>
                <Link
                  to="/hoarding-cleanup"
                  className="text-gray-700 hover:text-teal-600 font-medium py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Hoarding Cleanup
                </Link>
                <Link
                  to="/trash-talk"
                  className="text-gray-700 hover:text-teal-600 font-medium py-2"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Trash Talk
                </Link>
                <a
                  href="tel:915-233-1754"
                  className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-3 rounded-md font-semibold text-center whitespace-nowrap cursor-pointer"
                >
                  915-233-1754
                </a>
              </nav>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
